import React from 'react';
import { useNavigate } from 'react-router-dom';

function ProfileIcon() {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/measurements')}
      className="profile-icon-btn"
      title="My Measurements"
      aria-label="Go to measurements"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    </button>
  );
}

export default ProfileIcon;
